import { de, enGB } from 'date-fns/locale';

export function getDateInputFormatFromLocale(locale: string): string {
  if (locale === 'mk-MK') {
    return 'dd.M.yyyy';
  }
  const dateFnsLocale = locale === 'de-DE' ? de : enGB;
  return dateFnsLocale.formatLong.date({ width: 'short' }).replace(/y+/g, 'yyyy');
}
